import React, {FC} from 'react'

type OmsChoiceModalProps = {
  onConnectAsOms: () => void
  onContinue: () => void
  isOmsContinueLoading?: boolean
}

const OmsChoiceModal: FC<OmsChoiceModalProps> = ({
  onConnectAsOms,
  onContinue,
  isOmsContinueLoading = false,
}) => {
  return (
    <div className='d-flex align-items-center justify-content-center py-8 px-3'>
      <div className='card w-100 mw-980px border-0 shadow-none bg-transparent'>
        <div className='card-body p-7 p-lg-10'>
          <h2 className='mb-1 fw-bold text-dark text-center'>Welcome to Commercium</h2>
          <p className='text-gray-600 fs-4 mb-4 text-center'>
            Let&apos;s set up your integration workflow. Choose how you plan to use the platform
          </p>
          <div className='row g-4'>
            <div className='col-12 col-lg-5'>
              <div className='rounded p-2 h-100 d-flex flex-column bg-white'>
                <h4 className='fw-bold mb-2'>OMS Platform</h4>
                <p className='text-gray-700 fs-6 mb-4'>
                  Connect and use Commercium as your OMS and distribute orders to commerce
                  channels
                </p>
                <div className='mb-1'>
                  <img
                    src='/media/misc/oms-platform-flow.png'
                    alt='OMS platform workflow'
                    className='w-100 rounded-3'
                    style={{
                      boxShadow: '0 10px 30px rgba(28, 43, 90, 0.10)',
                      filter: 'saturate(1.06) contrast(1.03)',
                      opacity: 0.97,
                    }}
                  />
                </div>
                <button
                  type='button'
                  className='btn btn-primary mt-auto'
                  onClick={onConnectAsOms}
                  disabled={isOmsContinueLoading}
                >
                  {isOmsContinueLoading ? 'Saving...' : 'Continue'}
                </button>
              </div>
            </div>

            <div className='col-12 col-lg-2 d-none d-lg-flex align-items-center justify-content-center'>
              <div className='d-flex flex-column align-items-center w-100'>
                <div className='w-1px bg-gray-300' style={{height: '64px'}} />
                <span className='badge badge-light fw-bold text-gray-700 my-3 px-4 py-2'>OR</span>
                <div className='w-1px bg-gray-300' style={{height: '64px'}} />
              </div>
            </div>

            <div className='col-12 d-flex d-lg-none align-items-center justify-content-center'>
              <span className='badge badge-light fw-bold text-gray-700 px-4 py-2'>OR</span>
            </div>

            <div className='col-12 col-lg-5'>
              <div className='rounded p-2 h-100 d-flex flex-column bg-white'>
                <h4 className='fw-bold mb-2'>Multi-Commerce Sync</h4>
                <p className='text-gray-700 fs-6 mb-4'>
                  Sync products and orders across Source-Destination Marketplaces & Stores
                </p>
                <div className='mb-1'>
                  <img
                    src='/media/misc/multi-commerce-sync-flow.png'
                    alt='Multi-commerce sync workflow'
                    className='w-100 rounded-3'
                    style={{
                      boxShadow: '0 10px 30px rgba(28, 43, 90, 0.10)',
                      filter: 'saturate(1.06) contrast(1.03)',
                      opacity: 0.97,
                    }}
                  />
                </div>
                <button
                  type='button'
                  className='btn btn-light-primary mt-auto'
                  onClick={onContinue}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>

          <div className='text-center mt-7'>
            <button type='button' className='btn btn-link p-0 fw-semibold fs-6 text-primary'>
              Need help deciding? Compare setup options
            </button>
            <span className='text-primary ms-1' aria-hidden='true'>
              &rarr;
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OmsChoiceModal
